import { useLocation, useNavigate } from "react-router-dom";

export const useStatefulNavigator = <T>() => {
  const _navigate = useNavigate();
  const _location = useLocation();

  const navigate = (url: string, state?: T | "clearState") => {
    if (state === "clearState") {
      return _navigate(url);
    }

    if (typeof state === "undefined") {
      return _navigate(url, {
        state: _location.state,
      });
    }

    _navigate(url, {
      state,
    });
  };

  return {
    navigate,
    savedState: _location.state as T | undefined,
  } as const;
};
